import { Redirect } from 'react-router';

import PropTypes from 'prop-types';

const CommunityApprovalRedirect = ({ match }) => {
  const postId = match?.params?.postId;
  return (
    <Redirect
      to={{
        pathname: '/community/content-approval',
        state: { postId },
      }}
    />
  );
};

CommunityApprovalRedirect.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default CommunityApprovalRedirect;
